import React, { useEffect, useRef, useState } from "react";
import { useSnapshot } from "valtio";
import coachify_img from "../../../assets/img/coachify.png";
import coachify_1_img from "./ads/coachify_1.jpg";
import coachify_2_img from "./ads/coachify_2.jpg";
import coachify_3_img from "./ads/coachify_3.jpg";
import LogoIcon from "../../../desktop/public/icons/icon.svg?react";
import { platformState } from "../states/uiStates";

const COACH_ADS: Record<string, string> = {
	coachify_1: coachify_img,
	coachify_2: coachify_1_img,
	coachify_3: coachify_2_img,
	coachify_4: coachify_3_img,
};

interface AdViewProps {}

export interface LinkoraLink {
	uuid: string;
	text: string;
}

export const useLinkoraAd = (slug: string) => {
	const [adLink, setAdLink] = useState<null | { link: LinkoraLink | null }>(null);
	useEffect(() => {
		async function fetchAd() {
			const ad_response = await fetch(`https://link.duiker101.net/get/${slug}/`);
			const ad_result = await ad_response.json();
			if (!ad_result?.links?.length) {
				return;
			}
			setAdLink(ad_result.links[0]);
		}

		fetchAd();
	}, [slug]);

	return adLink?.link || null;
};

const WebAd = () => {
	const adLink = useLinkoraAd("riftkit_sb_sq");

	if (!adLink) return null;

	return (
		<a
			href={`https://link.duiker101.net/visit/${adLink.uuid}/`}
			target={"_blank"}
			rel={"noreferrer nofollow"}
		>
			<img src={COACH_ADS[adLink.text]} />
		</a>
	);
};

const AdView: React.FC<AdViewProps> = (props) => {
	const ref = useRef<HTMLDivElement>(null);
	const plaformSnap = useSnapshot(platformState);

	useEffect(() => {
		const timer = () => {
			if (!ref.current) return;
			if (!window.adError && !window.adReady) {
				setTimeout(timer, 1000);
				return;
			}

			if (window.adReady) {
				// @ts-ignore
				new OwAd(ref.current!, { size: { width: 400, height: 300 }, owAdTestAd: true });
			}
		};

		if (plaformSnap.platform == "desktop") timer();
	}, [plaformSnap.platform]);

	return (
		<div className={"relative"} style={{ height: 300, width: 400 }}>
			<div
				ref={ref}
				className={"absolute inset-0 flex items-center justify-center opacity-20"}
			>
				<LogoIcon width={280} height={280} />
			</div>
			<div ref={ref} className={"absolute inset-0"}>
				{plaformSnap.platform === "web" && <WebAd />}
			</div>
		</div>
	);
};

export { AdView };
